var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"another-projects"},[_c('h4',[_vm._v("Читайте также")]),_vm._l((_vm.projects),function(item,index){return _c('a',{key:index,staticClass:"project_item",style:({'background-image': `url(${item.bg})`}),attrs:{"href":item.link,"target":"_blank"},domProps:{"innerHTML":_vm._s(item.name)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }